import React from 'react';
import EditButton from '@sg/components/EditButton';
import DefaultGame from '@/pages/home/assets/img/common/game-default.svg';
import EllipsisText from '@sg/components/EllipsisText';
import moment from 'moment';
import { mapBoardGovernanceStatus } from '@sg/pages/StudioManagement/config';
import type { MeetingItemProps } from '@sg/pages/StudioManagement/BoardGovernanceNew/types';
import './index.scss';

const MeetingItem: React.FC<MeetingItemProps> = ({ item, isActive, onClick, isEditing, onEdit, noStudio }) => {
  const statusText = mapBoardGovernanceStatus(item.status);
  const statusClass = statusText.toLowerCase();

  const handleEditClick = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    // Also trigger onClick to change the meeting card
    onClick?.();
    if (onEdit) {
      onEdit(item);
    }
  };

  return (
    <div
      className={`dbs-meeting-item ${isActive ? '--active' : ''} ${noStudio ? 'dbs-meeting-nostudio' : ''}`}
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      {!noStudio && (
        <div className="dbs-meeting-item-title">
          <EllipsisText 
            text={item.title} 
            className="dbs-meeting-item-title-text"
          />
          {isEditing && (
            <EditButton 
              onClick={handleEditClick}
              title="Edit Meeting"
            />
          )}
        </div>
      )}
      <div className="dbs-meeting-item-figure">
        <div className="dbs-meeting-item-figure-logo">
          <img src={item.studio_cover || DefaultGame} alt="" />
        </div>
        <div className="dbs-meeting-item-figure-info">
          {noStudio ? (
            <div className="dbs-meeting-item-figure-title-wrapper">
              <EllipsisText 
                text={item.title} 
                className="dbs-meeting-item-figure-title"
              />
              {isEditing && (
                <EditButton 
                  onClick={handleEditClick}
                  title="Edit Meeting"
                />
              )}
            </div>
          ) : (
            <div className="dbs-meeting-item-figure-title">{item.studio_name}</div>
          )}
          <div className="dbs-meeting-item-figure-desc">
            <div className="dbs-meeting-item-figure-date">{moment(item.date).format('MM-DD')}</div>
            <div className={`dbs-meeting-item-figure-status --${statusClass}`}>
              {statusText}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingItem;
